// extracted by mini-css-extract-plugin
module.exports = {"ChannelCellContainer":"ChannelCell_ChannelCellContainer__2Ozv0","ChannelItem":"ChannelCell_ChannelItem__2fVNL"};